import Funnel from '../funnel/funnel.jsx';

const StateCSS = () => {
  return (
    <div style={{ textAlign: 'left' }}>
      <h1>CSS: Singe Page Apps</h1>
      <p>The UI below has a checkout funnel with a series of steps.</p>
      <p>The code to the right takes a CSS selector, checks if there is a match, and logs to console TRUE or FALSE if it is found along with the returned element</p>
      <p>We want a selector that results in a TRUE only when Step 2 is active, but unfortunately the selector on the right is too generic. Change the step and click <strong>Run</strong> to see for yourself</p>
      <p>Change the selector so it only returns TRUE when Step 2 is active.</p>
      <Funnel/>
    </div>
  )

}

export default StateCSS;